import { Injectable } from '@angular/core';

@Injectable()
export class LazyLoadConfig implements IntersectionObserverInit {
    public threshold = 0.1;

    public rootMargin = '-600px';

    public root = null;
}
